var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectFilterModalState } from '../../../store/structureBuilderUI/selectors';
import { logicFilters, primaryFilter } from './model';
import { HeaderContainer, ModalContent, SearchListItemInfo, SearchPatchworkName, SearchResult, SearchResultListItem, customModalStyles, } from './styles';
import { changeFilterPopUpState, fireEvent, updateModalPosition, } from 'store/structureBuilderUI/reducer';
import { clearCareerSource } from 'store/structureBuilderCarrer/reducer';
/**
 * Register Modal to the app root
 */
Modal.setAppElement('#app');
export var FilterModal = function (_a) {
    var patchFilter = _a.patchFilter, setFilters = _a.setFilters, filters = _a.filters, onClose = _a.onClose;
    var dispatch = useDispatch();
    var patchCategory = (patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length) ? logicFilters : primaryFilter;
    var isModalOpen = useSelector(selectFilterModalState);
    var actions = useMemo(function () { return ({
        closeModal: function () {
            dispatch(changeFilterPopUpState(false));
            dispatch(updateModalPosition(null));
        },
        clearCareerSource: function () {
            dispatch(clearCareerSource());
        },
        resetLinkEvent: function () {
            dispatch(fireEvent(''));
        },
    }); }, [dispatch]);
    var handleOnCloseModal = useCallback(function () {
        actions.closeModal();
        actions.resetLinkEvent();
        actions.clearCareerSource();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [actions, onClose]);
    var changeFilters = function (item) {
        var _a;
        if ((_a = filters.filter(function (i) { return i.type === item.type; })) === null || _a === void 0 ? void 0 : _a.length) {
            var modify = filters.filter(function (i) { return i.type !== item.type; });
            setFilters(modify);
            return;
        }
        filters.push(item);
        setFilters(filters);
    };
    var checkSelected = function (item) {
        var _a;
        return !!((_a = filters.filter(function (i) { return i.type === item.type; })) === null || _a === void 0 ? void 0 : _a.length);
    };
    return (_jsx(Modal, __assign({ isOpen: isModalOpen, onRequestClose: handleOnCloseModal, contentLabel: "Search Modal", style: customModalStyles(!!(patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length)), shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true }, { children: _jsxs(ModalContent, { children: [_jsx(HeaderContainer, { children: _jsx(SearchResult, { children: "Filter by type" }) }), _jsx(_Fragment, { children: patchCategory === null || patchCategory === void 0 ? void 0 : patchCategory.map(function (item) { return (_jsx(SearchResultListItem, __assign({ isSelected: checkSelected(item), onClick: function () {
                            changeFilters(item);
                        } }, { children: _jsxs(SearchListItemInfo, { children: [_jsx(FontAwesomeIcon, { color: 'black', size: '1x', icon: item.icon }), _jsx(SearchPatchworkName, { children: item === null || item === void 0 ? void 0 : item.label })] }) }), item === null || item === void 0 ? void 0 : item.type)); }) })] }) })));
};
